<template>
  <div class="profil">
    <FormModule
      :formIdentifier="formIdentifier"
      :editable="false"
      :saveable="false"
      :closable="false"
      @afterApiLoadWithError="zeigeSnackbarFehler()"
    >
      <template v-slot:header>
        <h2>
          Profil
        </h2>
      </template>
      <template v-slot:content>
        <b-unit no-header>
          <v-row justify="center">
            <v-col cols="4">
              <b-text-field
                  label="Projektträgerschaft"
                  v-model="projekttraegerschaft"
                  disabled
              />
            </v-col>
            <v-col cols="4">
              <b-text-field
                  label="Rolle"
                  :value="getRolle"
                  disabled
              />
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="4">
              <b-text-field
                  label="Anrede"
                  v-model="anrede"
                  disabled
              />
            </v-col>
            <v-col cols="4">
              <b-text-field
                  label="Titel"
                  v-model="titel"
                  disabled
              />
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="4">
              <b-text-field
                  label="Nachname"
                  v-model="nachname"
                  disabled
              />
            </v-col>
            <v-col cols="4">
              <b-text-field
                  label="Vorname"
                  v-model="vorname"
                  disabled
              />
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="4">
              <b-text-field
                  label="Telefon"
                  v-model="telefon"
                  disabled
              />
            </v-col>
            <v-col cols="4">
              <b-text-field
                  label="E-Mail Adresse"
                  v-model="email"
                  disabled
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="2">&nbsp;</v-col>
            <v-col>
              <b-btn @click="zeigePasswortAendernPopup = true">Passwort ändern</b-btn>
            </v-col>
          </v-row>
        </b-unit>
      </template>
    </FormModule>

    <PasswortAendernPopup
        v-if="zeigePasswortAendernPopup"
        :username="email"
        :profil="true"
        @close="zeigePasswortAendernPopup = false"
        @save="handlePasswordChange"
    />

    <v-snackbar v-model="showSnackbar" timeout="4000" color="primary">
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>

import dataMixin from "@/mixins/data-mixin";
import validations from "@/service/validations";
import FormModule from "@/components/base_components/FormModule";
import PasswortAendernPopup from "@/components/popups/PasswortAendernPopup";
import rollen from "@/utils/data/rollen";
import {mapMutations} from "vuex";

export default {
  name: 'Profil',
  components: {
    FormModule,
    PasswortAendernPopup
  },
  computed: {
    getRolle() {
      const rolle = this.ex_role.find((item) => item.value == this.rolle);
      return rolle ? rolle.text : '';
    }
  },
  mixins: [
    dataMixin('projekttraegerschaft', 'persistentData.projektTraegerschaft'),
    dataMixin('anrede', 'persistentData.anrede'),
    dataMixin('titel', 'persistentData.titel'),
    dataMixin('rolle', 'persistentData.rolle'),
    dataMixin('telefon', 'persistentData.telefon'),
    dataMixin('email', 'persistentData.email'),
    dataMixin('vorname', 'persistentData.vorname'),
    dataMixin('nachname', 'persistentData.nachname'),
  ],
  data() {
    return {
      hint: 'Pflichtfeld',
      rules: {
        required: (value) => !!value || this.hint,
      },
      showSnackbar: false,
      snackbarText: '',
      validations: validations,
      formIdentifier: { type: 'mitarbeiter', uuid: 'profile' },
      ex_role: rollen,
      zeigePasswortAendernPopup: false,
    };
  },
  methods: {
    ...mapMutations('formData', ['resetFormData']),
    handlePasswordChange() {
      this.snackbarText = 'Passwort erfolgreich geändert';
      this.showSnackbar = true;
    },
    zeigeSnackbarFehler() {
      this.snackbarText = 'Speichern fehlgeschlagen';
      this.snackbarColor = 'red';
      this.showSnackbar = true;
    },
  },
  created() {
    this.resetFormData();
  },
};
</script>

<style lang="scss" scoped>

.login {
  border: 1px solid #8A8A8A;
  padding: 80px;
  text-align: center;
  width: 66%;
  margin: 80px auto;
  h2 {
    text-align: left;
    padding-left: 12px;
  }
}

</style>